export default "__VITE_ASSET__DyKoW3So__"